if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cartRenderer = this.dataset.cartRenderer || 'auto';
        if (this.cartRenderer === 'notification') {
          this.cart = document.querySelector('cart-notification');
        } else {
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        }
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('.atc-text') || this.submitButton.querySelector('span');
        this.submitButton.addEventListener('click', this.onSubmitButtonClick.bind(this));

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.productCardQuickAdd = this.dataset.productCardQuickAdd === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        let quickAddSucceeded = false;

        if (this.productCardQuickAdd) {
          if (this._quickAddSuccessTimer) {
            clearTimeout(this._quickAddSuccessTimer);
            this._quickAddSuccessTimer = null;
          }
          this.submitButton.classList.remove('quick-add--success');
          const successIconReset = this.submitButton.querySelector('.quick-add-success-icon');
          if (successIconReset) successIconReset.classList.add('shopify-hidden');
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.setAttribute('aria-busy', 'true');
        this.submitButton.classList.add('loading', 'atc-loading');
        const loadingSpinner = this.querySelector('.loading__spinner');
        if (loadingSpinner) {
          loadingSpinner.classList.remove('hidden', 'shopify-hidden');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const productVariantId = formData.get('id');

        // Bulk deal flavor picker: each picked flavor becomes its own line item
        const flavorPicker = this.closest('product-info')?.querySelector('[data-flavor-picker]')?._flavorPicker;
        const flavorItems = flavorPicker?.getCartItems();
        if (flavorItems?.length) {
          formData.delete('id');
          formData.delete('quantity');
          formData.delete('selling_plan');
          flavorItems.forEach((item, index) => {
            formData.append(`items[${index}][id]`, item.id);
            formData.append(`items[${index}][quantity]`, item.quantity);
          });
        }

        // Bulk deal PDPs title the notification "<product> 3 x 12 pack added"
        const productInfo = this.closest('product-info');
        let addedSummary;
        if (this.cart?.setAddedSummary && productInfo?.querySelector('[data-volume-tiers]')) {
          const quantity = flavorItems?.length
            ? flavorItems.reduce((total, item) => total + item.quantity, 0)
            : parseInt(formData.get('quantity'), 10) || 1;
          // With picked flavors the notification shows pack 1's line
          const summaryVariantId = (flavorItems?.length && flavorPicker?.getPrimaryVariantId?.()) || productVariantId;
          addedSummary = { variantId: summaryVariantId, quantity };
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              if (this.cartRenderer === 'notification') return;
              window.location = window.routes.cart_url;
              return;
            }

            const hasPerf = typeof CartPerformance !== 'undefined';
            const startMarker = hasPerf ? CartPerformance.createStartingMarker('add:wait-for-subscribers') : null;
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId,
                cartData: response,
              }).then(() => {
                if (hasPerf) CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    if (addedSummary) this.cart.setAddedSummary(addedSummary);
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if (addedSummary) this.cart.setAddedSummary(addedSummary);
              this.cart.renderContents(response);
            }

            quickAddSucceeded = true;
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading', 'atc-loading');
            this.submitButton.removeAttribute('aria-busy');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');

            const loadingSpinner = this.querySelector('.loading__spinner');
            if (loadingSpinner) {
              loadingSpinner.classList.add('hidden', 'shopify-hidden');
            }

            const successIcon = this.submitButton.querySelector('.quick-add-success-icon');

            if (this.productCardQuickAdd && quickAddSucceeded) {
              if (successIcon) successIcon.classList.remove('shopify-hidden');
              this.submitButton.classList.add('quick-add--success');
              this._quickAddSuccessTimer = window.setTimeout(() => {
                this.submitButton.classList.remove('quick-add--success');
                if (successIcon) successIcon.classList.add('shopify-hidden');
                this.submitButton.removeAttribute('aria-disabled');
                this._quickAddSuccessTimer = null;
              }, 2000);
            } else if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }

            if (typeof CartPerformance !== 'undefined') CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = text || window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      onSubmitButtonClick(evt) {
        if (this.closest('a[href]')) {
          evt.preventDefault();
          evt.stopPropagation();
        }
      }
    }
  );
}
